import { useState } from 'react'

import { CustomFieldType } from '@tribeplatform/gql-client/types'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { List } from '@tribeplatform/react-ui-kit/Layout'

import { getFieldIcon, getFieldSetting } from '../CustomField/utils.js'
import { T } from '../i18n/components/T.js'
import { useStaticIntl } from '../i18n/hooks/useStaticIntl.js'

import { fieldTypesFactory } from './utils.js'

export const FieldTypePicker = ({ onChange, targetType }) => {
  const [items, setItems] = useState(null)
  const types = useStaticIntl(fieldTypesFactory)

  return (
    <List spacing="sm">
      {items && (
        <List.Item>
          <Button
            variant="secondaryNeutral"
            size="lg"
            className="w-full py-3 text-lg flex"
            leadingIcon={
              <SvgIcon className="rtl:-scale-x-100" name="arrow-left" />
            }
            onClick={() => {
              setItems(null)
            }}
          >
            <span>
              <T defaultMessage="Back" id="Generics.Back" />
            </span>
          </Button>
        </List.Item>
      )}
      {(items || types).map(item => {
        const subtype = getFieldSetting(item, 'subtype')

        if (
          targetType === 'member' &&
          item?.type === CustomFieldType.relation
        ) {
          return null
        }

        return (
          <List.Item key={item.name}>
            <Button
              variant="secondaryNeutral"
              size="lg"
              fullWidth
              className="py-3 text-lg"
              leadingIcon={getFieldIcon({
                type: subtype || item.type,
                typeOptions: item?.typeOptions,
              })}
              textAlign="start"
              onClick={() => {
                if (item?.children) {
                  setItems(item?.children)
                } else {
                  onChange(item)
                }
              }}
            >
              <div className="flex flex-col items-start ms-2">
                <span>{item.name}</span>
                {item.description ? (
                  <span className="font-normal text-sm text-start text-content-subdued">
                    {item.description}
                  </span>
                ) : null}
              </div>
            </Button>
          </List.Item>
        )
      })}
    </List>
  )
}
